import { Link } from "react-router-dom";
import { useBranding } from "@/contexts/BrandingContext";

export default function PublicFooter() {
  const branding = useBranding();
  return (
    <footer className="bg-[var(--color-bg-secondary)] border-t border-[var(--color-border)]">
      <div className="w-full px-4 sm:px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src={branding.logo_full} alt="KSM Services" className="h-7 w-auto drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)]" />
              <span className="text-sm font-bold text-[var(--color-text-primary)]">KSM Services</span>
            </div>
            <p className="text-sm text-[var(--color-text-secondary)] leading-relaxed max-w-xs">
              KASUMAR ofrece soluciones integrales de capacitación, consultoría y suministros para el sector Oil & Gas, industria y medio ambiente.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-[var(--color-text-primary)] uppercase tracking-wider mb-5">Enlaces</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Inicio</Link></li>
              <li><Link to="/#servicios" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Servicios</Link></li>
              <li><Link to="/#cursos" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Cursos</Link></li>
              <li><Link to="/#diplomados" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Diplomados</Link></li>
              <li><Link to="/#nosotros" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Nosotros</Link></li>
              <li><Link to="/#contacto" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Contacto</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-[var(--color-text-primary)] uppercase tracking-wider mb-5">Servicios</h4>
            <ul className="space-y-3">
              <li><Link to="/#cursos" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Capacitaciones</Link></li>
              <li><Link to="/#diplomados" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Diplomados</Link></li>
              <li><Link to="/" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Consultorías</Link></li>
              <li><Link to="/" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Suministros</Link></li>
              <li><Link to="/validar-certificado" className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-accent-oil)] transition-colors">Validación de Certificados</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-[var(--color-text-primary)] uppercase tracking-wider mb-5">Contacto</h4>
            <ul className="space-y-3">
              {branding.contact_phone && (
                <li className="flex items-center gap-2.5 text-sm text-[var(--color-text-secondary)]">
                  <i className="ri-phone-line text-[var(--color-text-accent)]"></i>
                  {branding.contact_phone}
                </li>
              )}
              {branding.contact_email && (
                <li className="flex items-center gap-2.5 text-sm text-[var(--color-text-secondary)]">
                  <i className="ri-mail-line text-[var(--color-text-accent)]"></i>
                  {branding.contact_email}
                </li>
              )}
              {branding.contact_address && (
                <li className="flex items-center gap-2.5 text-sm text-[var(--color-text-secondary)]">
                  <i className="ri-map-pin-line text-[var(--color-text-accent)]"></i>
                  {branding.contact_address}
                </li>
              )}
              {branding.contact_secondary_email && (
                <li className="flex items-center gap-2.5 text-sm text-[var(--color-text-secondary)]">
                  <i className="ri-mail-send-line text-[var(--color-text-accent)]"></i>
                  {branding.contact_secondary_email}
                </li>
              )}
            </ul>
            <div className="flex items-center gap-3 mt-5">
              {branding.social_linkedin && (
                <a href={branding.social_linkedin} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-lg bg-[var(--color-bg-card)] border border-[var(--color-border)] flex items-center justify-center text-[var(--color-text-muted)] hover:text-[var(--color-accent-oil)] hover:border-[var(--color-accent-oil)]/30 transition-all">
                  <i className="ri-linkedin-fill text-sm"></i>
                </a>
              )}
              {branding.social_facebook && (
                <a href={branding.social_facebook} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-lg bg-[var(--color-bg-card)] border border-[var(--color-border)] flex items-center justify-center text-[var(--color-text-muted)] hover:text-[var(--color-accent-oil)] hover:border-[var(--color-accent-oil)]/30 transition-all">
                  <i className="ri-facebook-fill text-sm"></i>
                </a>
              )}
              {branding.social_instagram && (
                <a href={branding.social_instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-lg bg-[var(--color-bg-card)] border border-[var(--color-border)] flex items-center justify-center text-[var(--color-text-muted)] hover:text-[var(--color-accent-oil)] hover:border-[var(--color-accent-oil)]/30 transition-all">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-[var(--color-border)] mt-14 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-5">
            <p className="text-xs text-[var(--color-text-muted)]">
              Copyright 2026 KASUMAR. Todos los derechos reservados.
            </p>
            <div className="hidden sm:block w-px h-3 bg-[var(--color-border)]"></div>
            <Link to="/legal" className="text-xs text-[var(--color-text-muted)] hover:text-[var(--color-accent-oil)] transition-colors">
              Política de Privacidad
            </Link>
            <div className="hidden sm:block w-px h-3 bg-[var(--color-border)]"></div>
            <Link to="/legal" className="text-xs text-[var(--color-text-muted)] hover:text-[var(--color-accent-oil)] transition-colors">
              Términos y Condiciones
            </Link>
          </div>
          <p className="text-xs text-[var(--color-text-muted)]">
            Desarrollado por KSM Training Management
          </p>
        </div>
      </div>
    </footer>
  );
}
